itsoftApp.createModule("animateTitle", function () {
    const module = this;

    const AnimateTitle = function (target) {

        this.container = target;

        this.init();
    };

    AnimateTitle.prototype.init = function () {
        const THIS = this;

        // Повторный запуск разбирает уже обёрнутый <i> ещё раз и выводит
        // разметку текстом — заголовок может прийти из двух наблюдателей
        if (THIS.container.classList.contains("_show")) {
            return;
        }
        const arr = THIS.container.innerHTML.match(/<span.*?>.*?<\/span>|\S+/g);
        let newArr = [];

        for (const el of arr) {
            let newEl = '';

            if (el.includes('<br>')) {
                newEl = el;
            } else {
                newEl = `<i>${el}</i>`;
            }

            newArr.push(newEl);
        }

        const text = newArr.join(' ');
        THIS.container.innerHTML = text;
        THIS.container.classList.add('_show');

        const containerWithImageInTheEnd = THIS.container.closest('.js-animate-title-with-image');
        const parts = THIS.container.querySelectorAll('i');
        /* по умолчанию вся анимация укладывается в 550ms, и у длинного заголовка
           шаг между словами становится меньше 50ms — при переходе 0.6s кажется,
           что текст появился сразу. data-speed задаёт шаг вручную */
        const customSpeed = parseInt(THIS.container.dataset.speed, 10);
        const speed = customSpeed > 0 ? customSpeed : (parts.length > 4 ? 550 / parts.length : 140);

        parts.forEach((el, index) => {
            setTimeout(() => {
                el.classList.add('_show');
            }, (index + 1) * speed);
        });

        // логотип в конце заголовка — <img> или инлайн-<svg> (/cartilox-t/)
        const img = containerWithImageInTheEnd && containerWithImageInTheEnd.querySelector("img, svg");

        if (img) {
            const delay = (parts.length + 1) * speed;

            setTimeout(() => {
                img.classList.add('_show');
            }, delay);
        }
    };

    module.callback = AnimateTitle;

});